import * as sagaEffects from 'redux-saga/effects';

import loginRequestHandler from './loginRequestHandler';
import logoutRequestHandler from './logoutRequestHandler';

const { all } = sagaEffects;

export default function* () {
    yield all([loginRequestHandler(), logoutRequestHandler()]);
}
